import thdCustomer from "@thd-olt-global/thd-customer";
import { askForOTPRequest, newUpdateEmailWithOTP } from "../../api/custAccountApi";
import {getErrorCode} from "../../utils/errors";
import { API_URLS } from "../../constants/urls";
import { setUrl } from "../../utils/urls";

export const buildOtpTicket = (data) => {
  const ticket = {};

  ticket.backendHostName = data.backendHostName;
  ticket.authId = data.authId;
  ticket.userId = data.userId;

  if (data.otpChannel === "phone") {
    ticket.phone = data.phoneNumber;
  } else {
    ticket.email = data.email;
  }

  return ticket;
};

export const buildOtpTicketWithoutUserId = (data) => {
  const ticket = {};

  ticket.backendHostName = data.backendHostName;
  ticket.authId = data.authId;
  ticket.userId = data.userId;
  ticket.autoToken = data.autoToken;

  if (data.otpChannel === "phone" || data.otpChannel === "sms") {
    ticket.phone = data.phoneNumber;
  } else {
    ticket.email = data.email;
  }

  return ticket;
};

// Helper functions to call APIs during new Verify OTP Modal flow
export const callOtpValidate = (otpCode, email, apiContext, account, setApiContext) => new Promise((resolve, reject) => {
  const {
    autoToken,
    requestOtpTicket,
  } = apiContext;

  return newUpdateEmailWithOTP(otpCode, email, requestOtpTicket, account, autoToken).then(({ response, error }) => {
    if (response) {
      setApiContext({
        requestOtpTicket: {
          ...apiContext.requestOtpTicket,
          userId: response.data?.identity?.userId
        },
        persistedUserId: response.data?.identity?.userId,
      });
      resolve();
    } else if (error) {
      const errorCode = getErrorCode(error);
      if((errorCode === "PASS_ERR_015") && (!!error?.response?.headers?.authid)){
        setApiContext({
          requestOtpTicket: {
            ...apiContext.requestOtpTicket,
            authId: error?.response?.headers?.authid
          },
        });
      }
      reject(error);
    }
  }).catch((error) => {
    reject(error);
  });
});

/**
 * Helper function meant to simplify API request call logic for modal
 * @param {ApiiRequestPayload} payload
 */
export const callOtpRequest = (
  payload
) => new Promise((resolve, reject) => {
  const {
    flowName,
    currentEmail,
    emailOtp,
    account,
    setApiContext,
    autoToken
  } = payload;

  let otpRequestChannel = "";
  if (flowName === "smsOtpRequest") {
    otpRequestChannel = "sms";
  } else if (flowName === "evoiceOtpRequest") {
    otpRequestChannel = "phone";
  } else if (flowName === "emailOtpRequest") {
    otpRequestChannel = "email";
  }

  if(!thdCustomer.isLoggedIn || thdCustomer.isPersisted) {
    setUrl("", API_URLS.SIGNIN);
    return
  }

  return askForOTPRequest(currentEmail, emailOtp, account.encryptVerifiedPhoneToken, otpRequestChannel, autoToken)
    .then(({ response, error }) => {
      if (response) {
        const ticket = buildOtpTicket(response.data);
        setApiContext({
          ...(response.data?.autoToken && {autoToken: response.data.autoToken}),
          requestOtpTicket: ticket
        });
        resolve(response);
      } else if (error) {
        reject(error);
      }
    })
    .catch((error) => {
      reject(error);
    });
});
